<template>
  <div>
    <div class="">
      <div class="handle-box">
        <el-input
          size="small"
          placeholder="个人名称"
          v-model.trim="name"
          class="handle-input mr10"
        ></el-input>
        <el-select size="small" v-model="payType" class="handle-select mr10">
          <el-option
            v-for="item in payData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-table
        :data="data.records"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column
          width="200px"
          header-align="center"
          label="用户名称"
          prop="orderNo"
        >
          <template #default="scope">
            <ul>
              <li>订单号:{{ scope.row.orderCode }}</li>
              <li>{{ scope.row.nickname }}</li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="realname"
          label="联系人"
        ></el-table-column>
        <el-table-column
          width="130px"
          prop="username"
          label="联系电话"
          align="center"
        ></el-table-column>
        <el-table-column label="购买时间" width="170" align="center">
          <template #default="scope">
            {{ $utils.formatDate(scope.row.time, "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column min-width="100px" align="center" label="支付金额">
          <template #default="scope">{{ scope.row.paidInPrice }}元 </template>
        </el-table-column>
        <el-table-column min-width="100px" align="center" label="支付方式">
          <template #default="scope">
            <ul>
              <li>
                {{
                  scope.row.payType === 1
                    ? "微信支付"
                    : scope.row.payType === 2
                    ? "支付宝支付"
                    : "公户转账"
                }}
              </li>
              <li v-if="scope.row.payType === 3">
                <el-button type="text" @click="payment(scope.row)"
                  >查看转账信息</el-button
                >
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column width="170px" align="center" label="订单生效时间">
          <template #default="scope">
            <el-link
              type="success"
              :underline="false"
              href="javascript:void(0);"
            >
              {{
                $utils.formatDate(scope.row.auditTime, "yyyy-MM-dd hh:mm:ss")
              }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          width="170"
          align="center"
          label="操作人"
          prop="operator"
        >
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="data.current"
          :page-size="20"
          :total="data.total"
          @current-change="getData"
        ></el-pagination>
      </div>

      <!-- 付款信息 -->
      <el-dialog title="付款信息" v-model="payment_dialog" width="800px" center>
        <div class="payment_dialog-body">
          <el-form size="mini">
            <el-form-item label="付款账号:">{{
              itemData.paymentAccount
            }}</el-form-item>
            <el-form-item label="付款人:">{{ itemData.payer }}</el-form-item>
            <el-form-item label="付款银行:">{{
              itemData.paymentBank
            }}</el-form-item>
            <el-form-item label="付款时间:">{{
              itemData.paymentTime
            }}</el-form-item>
            <el-form-item label="付款凭证:">{{
              !itemData.paymentVoucher ? "无凭证" : ""
            }}</el-form-item>
            <el-form-item v-if="itemData.paymentVoucher">
              <img
                :src="$utils.fileUrl(itemData.paymentVoucher)"
                v-if="
                  $utils.fileType(itemData.paymentVoucher) === 'png' ||
                  $utils.fileType(itemData.paymentVoucher) === 'jpg'
                "
                alt=""
              />
              <template v-else>
                <embed
                  :src="$utils.fileUrl(itemData.paymentVoucher)"
                  type="application/pdf"
                />
              </template>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { h } from "vue";

export default {
  data() {
    return {
      data: {},
      name: "",
      payType: "",
      payData: [
        { label: "全部", value: -1 },
        { label: "微信", value: 1 },
        { label: "支付宝", value: 2 },
        { label: "公户转账", value: 3 },
      ],
      itemData: {},
      loading: false,
      payment_dialog: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      if (this.name.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          payType: this.payType === -1 ? null : this.payType,
          name: this.name,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.invest.complete.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    payment(data) {
      this.itemData = data;
      this.payment_dialog = true;
    },
  },
  watch: {
    payType: {
      handler(val, ovl) {
        this.getData();
      },
    },
    name: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-select {
  width: 150px;
}

.handle-box {
  margin-bottom: 20px;
}

.payment_dialog-body {
  embed {
    width: 100%;
    height: 800px;
  }
  img {
    width: 100%;
  }
}
</style>


